<template lang="pug">
filter-detail-container(title="Filter time" :save-mode="false" @back="back" @clear="clear" @save="save")
  template(v-slot:body)
    .pa-6
      div Filter appointment made on:
      yc-select.mt-4(v-model="condition" :items="options")
      y-time-picker.py-4(v-model="startTime")
      v-divider
      template(v-if="condition === 'between'")
        .text-center.text-sm.py-3 Until:
        v-divider
        y-time-picker.py-4(v-model="endTime")
        v-divider
</template>

<script>
import FilterDetailContainer from '@/components/connect/FilterDetailContainer.vue'
import YTimePicker from '@/components/YTimePicker.vue'

export default {
  props: {
    filter: {
      type: Object,
      default: () => {}
    }
  },
  components: { FilterDetailContainer, YTimePicker },
  data: () => ({
    condition: 'before',
    times: null,
    options: [
      { id: 'before', label: 'Before' },
      { id: 'after', label: 'After' },
      { id: 'exact', label: 'Exact time' },
      { id: 'between', label: 'In between' }
    ],
    startTime: null,
    endTime: null,
  }),
  created () {
    const { before, after, exact, between } = this.filter
    if (before) {
      this.condition = 'before'
      this.startTime = before
    }
    if (after) {
      this.condition = 'after'
      this.startTime = after
    }
    if (exact) {
      this.condition = 'exact'
      this.startTime = exact
    }
    if (between) {
      this.startTime = between.start
      this.endTime = between.end
    }
  },
  methods: {
    save () {
      const filter = this.getFilterData()
      this.$emit('update:filter', filter)
      this.back()
    },
    getFilterData () {
      switch (this.condition) {
        case 'before':
          return { before: this.startTime }
        case 'after':
          return { after: this.startTime }
        case 'exact':
          return { exact: this.startTime }
        case 'between':
          return {
            between: {
              start: this.startTime,
              end: this.endTime
            }
          }
        default:
          return {}
      }
    },
    back () {
      this.$emit('onBack')
    },
    clear () {
      this.startTime = null
    }
  }
}
</script>
